import { render, staticRenderFns } from "./HomepagePriceTable.vue?vue&type=template&id=15c48518&"
import script from "./HomepagePriceTable.vue?vue&type=script&lang=js&"
export * from "./HomepagePriceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports